<template>
  <el-select
    v-model="value"
    filterable
    remote
    :style="{width:'278px'}"
    size="mini"
    placeholder="Search & Select"
    :remote-method="handleQuery"
    :loading="loading"
  >
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>
  </el-select>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getSuppliers } from '../api'

export default {
  name: 'ReportSupplierDesignate',
  props: {
    rowId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      options: [],
      loading: false
    }
  },
  computed: {
    ...mapState('report', ['selectedSuppliers']),
    value: {
      get () {
        return this.selectedSuppliers.find(c => c.id === this.rowId).supplier.name
      },
      set (val) {
        this.setSupplier({ id: this.rowId, supplier: val })
      }
    }
  },
  methods: {
    ...mapMutations({
      setSupplier: 'report/setSupplier'
    }),
    async handleQuery (name) {
      if (name !== '') {
        this.loading = true
        let data = await getSuppliers({ name: name })

        this.options = data.data.map(item => ({ value: item.id, label: item.name, ...item }))
        this.loading = false
      }
    }
  }
}
</script>
